import { Control } from "Controls/Control";
import { DisplayModes } from "Enums";
import { ControlTemplate } from "Controls/Entities";

/**
 * Empty control which shows a unsupported message.
 * @hidden
 */
export class UnsupportedControl extends Control {
    protected dmsControlClass: string = "dms-control-unsupported";

    /**
    * Internal method for setElement.
    * @param element JQueryElement for initialization.
    */
    protected setElementInternal(element: JQuery): void {
    }

    /**
     * Not implemented for this control.
     */
    public getValue(): string {
        return null;
    }

    /**
     * Not implemented for this control.
     * @param value
     */
    public setValue(value: string) {
    }

    /**
     * Internal method for getting the template.
     * @param displayMode DisplayMode for control.
     * @param bindingField Field which the control is bound to.
     */
    protected getTemplateInternal(displayMode: DisplayModes, bindingField?: string): ControlTemplate {
        let controlTemplate = new ControlTemplate();
        let element = $("<span style=\"color:red\">Unsupported control type</span>");
        controlTemplate.element = element;
        controlTemplate.template = element[0].outerHTML;
        controlTemplate.editable = false;
        return controlTemplate;
    }

    /**
     * Dispose the control and release all resources.
     */
    public dispose(): void {
        super.dispose();
    }
}
